import SectionProvider from '@/sections/SectionProvider'

export const name = 'Product Variants'
export const group = ''

export default class ElProductVariant extends SectionProvider {
  constructor (options = {}) {
    super('ElProductVariant', options)

    this.name = name
    this.group = group
  }
}